<script setup>
const props = defineProps({ blok: Object })
const body = computed(() => renderRichText(props.blok.body, {
		resolver: (component, blok) => {
			return `<component :blok='${JSON.stringify(blok)}' is="${component}" />`
		},
	}))
</script>

<template>
  <div v-editable="blok" class="pt-20 w-full">
		<h3 v-if="blok.title" class="text-4xl font-bold pb-12">{{ blok.title }}</h3>
		 <div class="section-body gap-20 md:columns-2" v-html="body"></div>
		<!-- <Vue3RuntimeTemplate class="section-body gap-20 md:columns-2" :template="body"></Vue3RuntimeTemplate>  -->
  </div>
</template>
 

<style>
.section-body blockquote:after {
    position: absolute;
    content: open-quote;
    color: #be8dff88;
    font-size: 8rem;
		font-style: normal;
    line-height: 0;
    top: -3.2rem;
    left: -0.75rem;
}

.section-body blockquote:before {
    position: absolute;
    content: "”";
    color: #be8dff88;
    font-size: 8rem;
		font-style: normal;
		
    line-height: 0;
    bottom: .2rem;
    right: .5rem;
}

.section-body a {
	color: #BF8DFF;
}

.section-body b {
	font-weight: 600;
	color: white;
}

.section-body h4 {
	padding-top: 40px;
	padding-bottom: 20px;
	font-size: 1.4rem;
	font-weight: 400;
}

.section-body h4:first-child {
	padding-top: 0px !important;
}

.storyblok__outline ul {
	margin-top: 20px;
	margin-bottom: 40px;
}

.storyblok__outline ul li {
	margin-left: 40px;
	list-style-type: disc;
	margin-bottom: 20px;
}

.section-body .storyblok__outline > p {
	margin-bottom: 40px;
}


.section-body img {
	border-radius: 1.5rem;
	margin: 2.5rem 2rem 2.5rem 0;
	float: left;
	display: block;
	clear: both;
}


</style>